import fetchWrapper from './fetchWrapper';

const fetchUsers = async (isAdmin) => {
  const token = localStorage.getItem('token');
  let url = '/api/auth/users';
  if (isAdmin === true || isAdmin === false) {
    url += `?isAdministrator=${isAdmin}`;
  }
  const response = await fetchWrapper(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch users');
  }
  return response.json();
};

export { 
  fetchUsers,
};
